// extracted by mini-css-extract-plugin
export default {"calendarWrapper":"hireCandidateModal_calendarWrapper__KR6QN","hireCandidateDesc":"hireCandidateModal_hireCandidateDesc__BAWa0"};